import { cn } from "../lib/utils.js";
import "react";
import { jsx } from "react/jsx-runtime";
import * as LabelPrimitive from "@radix-ui/react-label";
//#region src/components/label.tsx
const Label = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(LabelPrimitive.Root, {
		"data-slot": "label",
		className: cn("tw:flex tw:items-center tw:gap-2", "tw:text-sm tw:leading-none tw:font-medium", "tw:group-data-[disabled=true]:pointer-events-none tw:group-data-[disabled=true]:opacity-50", "tw:peer-disabled:cursor-not-allowed tw:peer-disabled:opacity-50", className),
		...props
	});
};
//#endregion
export { Label };

//# sourceMappingURL=label.js.map